module.exports = __webpack_public_path__ + "static/media/stop-w.3c2ad181.svg";